import useApi from '../use-api';

import type { IDownloadAudioComment } from 'infrastructure/interfaces';

export const useGetAudioComment = (patientGuid: string) => {
  const { loading, isMounted, loadData } = useApi({ canAbort: false });

  const getAudioCommentUrl = async (
    callId: string,
  ): Promise<IDownloadAudioComment | void> => {
    const endpoint = `core/patients/${patientGuid}/call-record/${callId}`;
    const data = await loadData<IDownloadAudioComment>(endpoint);
    if (isMounted && data) {
      return data;
    }
  };

  return {
    getAudioCommentUrl,
    loading,
  };
};
